import React, { useContext } from 'react';
import { useAppSelector } from 'src/app/store/stateTypeHook';
import { AuthContext } from 'src/app/contexts/authContext';
import { SidebarContext } from '../../contexts/SidebarContext';
// material ui components
import { Avatar, Box, Button, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
// icons
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// shared components
import CustomBreadcrumbs from '../breadcrumbs/Breadcrumbs.component';
// icons
import accountTopbarIcon from '../../assets/icons/profile-icon.svg';
import Logo from '../../assets/icons/airportr_logo_mobile.svg';
import NotificationsOverlay from 'src/app/containers/app-notifications/NotificationsOverlay';

const HeaderComponent = () => {
    const { logout } = useContext(AuthContext);
    const { toggleSidebar } = useContext(SidebarContext);
    const { loggedinUser: user } = useAppSelector((state) => {
        return state.user;
    });

    const [anchorUserMenu, setAnchorUserMenu] = React.useState(null);

    const openUserMenu = Boolean(anchorUserMenu);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorUserMenu(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorUserMenu(null);
    };

    return (
        <>
            <Toolbar
                sx={{
                    p: { xs: '0 16px', md: '0 30px' },
                    paddingTop: { md: '25px', xs: '20px' },
                    paddingBottom: { md: '15px', xs: '20px' },
                    flexDirection: {
                        xs: 'column',
                        md: 'row',
                    },
                }}
            >
                <Box
                    display={'flex'}
                    alignItems={'center'}
                    sx={{
                        width: 1,
                    }}
                >
                    <IconButton
                        size='large'
                        edge='start'
                        color='inherit'
                        aria-label='open drawer'
                        sx={{
                            mr: 2,
                            display: {
                                lg: 'none',
                            },
                        }}
                        onClick={toggleSidebar}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Box alignItems={'center'} sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <CustomBreadcrumbs />
                    </Box>

                    <Box
                        alignItems={'center'}
                        justifyContent={'center'}
                        sx={{
                            flexGrow: 1,
                            display: { xs: 'flex', md: 'none' },
                        }}
                    >
                        <img src={Logo} height='30px' alt='Air Portr' />
                    </Box>

                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: [null, null, '16px'] }}>
                            {user.userId && <NotificationsOverlay />}
                            <Button
                                sx={{
                                    padding: 0,
                                    textTransform: 'none',
                                    justifyContent: 'flex-end',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                    '& .MuiButton-endIcon': {
                                        display: { xs: 'none', md: 'flex' },
                                    },
                                }}
                                onClick={handleOpenUserMenu}
                                size='small'
                                aria-controls={openUserMenu ? 'user-menu' : undefined}
                                aria-haspopup='true'
                                aria-expanded={openUserMenu ? 'true' : undefined}
                                endIcon={<KeyboardArrowDownIcon sx={{ display: { xs: 'none', md: 'flex' } }} />}
                                disableRipple={true}
                            >
                                <Box sx={{ display: { xs: 'none', md: 'flex' }, px: '15px' }}>
                                    <Typography variant='subtitle1'>{`${user.firstName ?? ''} ${
                                        user.lastName ?? ''
                                    }`}</Typography>
                                </Box>
                                <Avatar
                                    sx={{ width: { xs: '28px', md: '36px' }, height: { xs: '28px', md: '36px' } }}
                                    src={accountTopbarIcon}
                                    alt='account icon'
                                />
                            </Button>
                        </Box>

                        <Menu
                            id='user-menu'
                            anchorEl={anchorUserMenu}
                            open={openUserMenu}
                            onClose={handleCloseUserMenu}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem
                                onClick={() => {
                                    handleCloseUserMenu();
                                    logout();
                                }}
                            >
                                Log Out
                            </MenuItem>
                        </Menu>
                    </Box>
                </Box>

                <Box
                    alignItems={'center'}
                    sx={{
                        width: 1,
                        display: { xs: 'flex', md: 'none' },
                        mt: '12px',
                    }}
                >
                    <CustomBreadcrumbs />
                </Box>
            </Toolbar>
        </>
    );
};

export default HeaderComponent;
